import mainSlider from './mainSlider';
export default function vimeoWidget() {
  const widgetName = 'vimeoWidget';
  const widgetOpts = vimeoWidgetOpts;

  function createCustomMainVideoFesT(data) {
    let vimeoURLAttr = $(data.Description).find('iframe').attr('src');
    vimeoURLAttr = `${vimeoURLAttr}&background=1`;
    $(`#${widgetName}`).find('.card-widget-description iframe').attr('src', vimeoURLAttr);
    $(`#${widgetName}`).find('.card-widget-title').remove();
    $(`#${widgetName}`).find('.buttonwrap').remove();
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (slide, _owl, hasData) {
      if (hasData) {
        $('.slideshow2-wrapper').remove();
        createCustomMainVideoFesT(slide.items[0]);
      } else {
        $(`#${widgetName}`).parent().remove();
        mainSlider();
      }
    },

    itemsPerPanel: 1,
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
  });
}
